import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Space, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import {
  LANGUAGES,
  getLanguage,
  localizePath,
  stripLanguage,
} from "../i18n/languages";
import "./LanguageSelector.css";

export default function LanguageSelector() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { pathname, search, hash } = useLocation();

  // Switching language keeps the visitor on the same page: /about -> /fr/about
  const handleMenuClick = ({ key }) => {
    navigate(localizePath(stripLanguage(pathname), key) + search + hash);
  };

  const menuProps = {
    items: LANGUAGES.map(({ code, label }) => ({
      key: code,
      label: <span lang={code}>{label}</span>,
    })),
    selectable: true,
    selectedKeys: [i18n.resolvedLanguage],
    onClick: handleMenuClick,
  };

  return (
    <div className="language-selector-container">
      <Dropdown menu={menuProps} trigger={["click"]}>
        <Button
          className="language-btn"
          aria-label={`${getLanguage(i18n.resolvedLanguage).label} – ${t(
            "language.label"
          )}`}
        >
          <Space>
            {getLanguage(i18n.resolvedLanguage).label}
            <DownOutlined />
          </Space>
        </Button>
      </Dropdown>
    </div>
  );
}
